import { Directive, inject } from '@angular/core'
import { DIALOG_DATA, DialogRef } from '@angular/cdk/dialog'

/**
 * Compat shim nahrazující `SimpleModalComponent` z abandoned `@looorent/ngx-simple-modal`.
 *
 * Zachovává API které dialog komponenty používají:
 *  - `result` (settable, čte se při close) — jako getter/setter, ne plain field, aby fungoval
 *    `super.result = x` v potomcích (TS 5.x zakazuje `super.<field>`, TS2855; accessor přes
 *    prototype je OK)
 *  - `close()` metoda (vrací Promise — některé komponenty řetězí `close().then(...)`)
 *
 * Vstupní data jsou dostupná dvěma způsoby:
 *  - `dialogData` (CDK `DIALOG_DATA`) — pro nové / CDK-native komponenty,
 *  - jako instance properties — `SimpleModalService` / `DialogService` je `Object.assign`ují
 *    na instanci hned po `dialog.open()` (před prvním change detection / ngOnInit), což
 *    odpovídá timing semantice původního ngx-simple-modal `mapDataObject` a je nezávislé
 *    na `useDefineForClassFields`.
 *
 * Pozn.: field je `dialogData`, NE `data` — některé komponenty deklarují vlastní `data` field
 * (např. BarterUpdateParcelAcreageDialogComponent) a kolidovaly by s base classou.
 */
@Directive()
export abstract class CaDialogComponent<TData = unknown, TResult = unknown> {

    protected readonly dialogData = inject<TData>(DIALOG_DATA, { optional: true })

    private readonly dialogRef = inject<DialogRef<TResult>>(DialogRef)

    private _result: TResult

    get result(): TResult {
        return this._result
    }

    set result(value: TResult) {
        this._result = value
    }

    close(): Promise<void> {
        this.dialogRef.close(this._result)
        return Promise.resolve()
    }
}